// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {getNewGamesService} from "../../services/games/gamesList/newGames.service";

export const useGetNewGames = provider => {
  const {data, isPending} = useQuery({
    queryKey: ["newGames", provider],
    queryFn: () => getNewGamesService(provider),
  });
  return {
    data,
    isPending,
  };
};
